/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const EpisodeNextLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="episode-next-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1076.6666666666665 170H1190V1190H1076.6666666666665V170zM170 170L906.6666666666666 680L170 1190V170zM707.54 680L283.3333333333333 386.3533333333335V973.7033333333334L707.54 680z" : "M861.3333333333334 136H952V952H861.3333333333334V136zM136 136L725.3333333333334 544L136 952V136zM566.032 544L226.6666666666667 309.0826666666667V778.9626666666666L566.032 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
EpisodeNextLg.displayName = `Blueprint5.Icon.EpisodeNextLg`;
export default EpisodeNextLg;
